<template>
    <div :class="['detail-wrap', {'detail-warp-drawer': getIfClientDrawerTag}]">
        <VHeader></VHeader>
        <NewKeeBreadcrumb :class="['kee-b', {'wl-container-course-detail-drawer': getIfClientDrawerTag}]"></NewKeeBreadcrumb>
        <el-row :class="['wl-container-course-detail', {'wl-container-course-detail-drawer': getIfClientDrawerTag}]" v-loading="loading">
            <el-col :span="18" class="__left">
                <div class="__inner">
                    <!--线上课程-->
                    <div v-if="courseInfo.form === 'ONLINE'">
                        <div class="course-video">
                            <div class="video-content">
                                <div v-if="!isKpmgUser" id="player"></div>
                                <img v-else :src="courseInfo.coverImgUrl" alt="" style="width: 100%; height: 100%" />
                            </div>
                            <div class="course-content">
                                <div>
                                    <div class="course-header-title">{{ courseInfo.title }}</div>
                                    <div class="course-content-detail">{{ courseInfo.remark }}</div>
                                    <div class="course-price">
                                        <el-tag type="primary" size="mini" style="background: #1E49E20F;color: #1E49E2;">
                                            {{ courseInfo.form === 'ONLINE' ? $t('courseInfo_online') : $t('courseInfo_offline') }}
                                        </el-tag>
                                        <el-tag :type="courseInfo.chargeType === 'FREE' ? 'success' : 'danger'"
                                            size="mini" :style="[courseInfo.chargeType === 'FREE' ? {'margin-left': '10px','background': '#1E49E20F','color': '#1E49E2'} : {'margin-left': '10px'}]">
                                            {{ courseInfo.chargeType === 'FREE' ? $t('kee_free') : $t('kee_charge') }}
                                        </el-tag>
                                    </div>
                                    <div class="course-time">
                                        <div style="font-size: 12px">
                                            {{ $t('kee_duration') }}:
                                            <span>
                                                {{ durationTrans(courseInfo.sumDurationFormat) }}
                                            </span>
                                        </div>
                                        <div style="font-size: 12px; margin: 0 20px;">{{ $t('kee_viewed', {
                                            num:
                                            courseInfo.viewNum }) }}</div>
                                        <div v-show="getUser.userType == '2'" class="course-collect"
                                            @click.stop="collectClick(courseInfo)">
                                            <img src="@/assets/img/icon-collect.svg" v-if="courseInfo.collectFlag"
                                                class="collect-icon" width="100%" />
                                            <img src="@/assets/img/icon-uncollect.svg" v-else class="collect-icon"
                                                width="100%" />
                                            <span style="font-size: 12px;">{{ $t('kee_like') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!--<div>
                                    <el-button @click="watchVideo(courseInfo.volumes[0].videoId, true)"
                                        icon="el-icon-video-play" type="primary">
                                        {{ $t('startCourse') }}
                                    </el-button>
                                </div>-->
                            </div>
                        </div>
                        <div class="course-item">
                            <div class="course-item-content">
                                <div v-for="(item, key) in courseInfo.volumes" :key="key" class="course-list-item-kc"
                                    @click.stop.prevent="watchVideo(item.videoId, true)">
                                    <div class="course-item-child"
                                        :class="item.viewingCompletion == 1 ? 'isWatched' : ''"
                                        @click="openDetail(item)">

                                        <div class="circle">{{key + 1}}</div>
                                        <div :class="[
                                            'item-title',
                                            item.videoId == currentVideo ? 'item-title-active' : '',
                                            item.showDesc ? 'isActive' : ''
                                        ]" :title="item.title">
                                            {{ item.title }}
                                        </div>
                                        <div :class="['iconNew', $i18n.locale === 'en' ? '__en' : '']" v-if="item.newFlag == '1'"></div>
                                        <div class="item-time">
                                            <svg-icon icon-name="kee-date" :size="16" style="margin-left: 10px;" :title="$t('kee_update_time')"></svg-icon>
                                            <div class="time-val" :title="$t('kee_update_time')" style="width: 100px;">{{ item.keeUpdateTime | formatDateTime2}}</div>
                                            <svg-icon :title="$t('kee_duration')" icon-name="kee-time" :size="16" style="margin-left: 6px;border-left: solid 1px #666666;padding-left: 10px;"></svg-icon>
                                            <div class="time-val" :title="$t('kee_duration')" :style="!isKpmgUser ? 'margin-left: 0px;' : 'margin-left: 10px;'">{{ item.duration }}</div>
                                            <svg-icon :title="$t('kee_see_num')" icon-name="kee-see-num" :size="16" style="margin-left: 10px;border-left: solid 1px #666666;padding-left: 10px;"></svg-icon>
                                            <div :title="$t('kee_see_num')" class="time-val"style="width: 20px;">{{item.viewNum}}</div>
                                            <!-- <div class="time-val">{{item.viewingCompletion * 100}}%</div> -->
                                            <svg-icon v-if="!isKpmgUser" :title="$t('kee_play')" icon-name="kee-start" :size="20" style="margin-left: 20px;" @click.stop.prevent="watchVideo(item.videoId, true)"></svg-icon>
                                        </div>
                                    </div>
                                    <el-collapse-transition>
                                        <div v-show="item.showDesc">
                                            <div class="course-item-desc">{{ item.remark }}</div>
                                        </div>
                                    </el-collapse-transition>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--线下课程-->
                    <div v-if="courseInfo.form === 'OFFLINE'" class="offline-cource-box" style="overflow-y: auto;">
                        <div class="course-offline-content">
                            <div class="course-header-title mb-15">{{ courseInfo.title }}</div>
                            <div class="flex justify-between my-20" v-if="false">
                                <div class="border-normal course-container">
                                    <div class="course-offline-child" v-html="courseInfo.remark"></div>
                                    <div class="course-price" v-if="courseInfo.chargeType === 'CHARGED'">
                                        {{ $t('kee_price') }}: <span class="price-value">￥{{ courseInfo.priceDesc
                                        }}</span>
                                    </div>
                                    <div class="course-price" v-if="courseInfo.chargeType === 'CHARGED'">
                                        {{ $t('kee_discount') }}:
                                        <span class="sales-content"><i class="el-icon-warning"></i>{{
                                            courseInfo.discountDescription }}</span>
                                    </div>
                                </div>
                                <div class="border-normal qr-container">
                                    <div class="qr-image ">
                                        <el-image :src="'data:image/png;base64,' + courseInfo.signupQrCodeByte" alt />
                                        {{ $t('scan_qr_for_register') }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="courseInfo.content" v-html="courseInfo.content"></div>

                        </div>
                    </div>
                </div>

            </el-col>

            <el-col :span="6" class="__right">
                <div class="__inner">
                    <RecommendList></RecommendList>
                </div>
            </el-col>
        </el-row>
        <vBottom></vBottom>
    </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import VHeader from '@/components/common/Header.vue'
import VBottom from '@/components/common/Bottom'
import RecommendList from './RecommendList.vue'
import NewKeeBreadcrumb from './NewKeeBreadcrumb.vue'
import SvgIcon from "@/components/svgIcon/index";

export default {
    name: 'courseDetailNew',
    components: {
        VHeader,
        VBottom,
        RecommendList,
        NewKeeBreadcrumb,
        SvgIcon
    },
    data() {
        return {
            vodPlayerJs: 'https://player.polyv.net/script/player.js',
            loading: false,
            isOnline: false,
            courseInfo: {},
            vid: '',
            playsafe: '',
            player: null,
            isAutoplay: false,
            currentVideo: ''
        }
    },
    async mounted() {
        await this.getCourseDetail()
        if (this.isKpmgUser && this.courseInfo.form !== 'OFFLINE') {
                if(this.getIfClientDrawerTag ){
            this.$message.warning({
                dangerouslyUseHTMLString: true,
                message: '<span style="font-size: 12px;">'+this.$t('kee_kp_view_in_mp_new')+'</span>',
                duration: 5000
            }) 
            }else{
                this.$message.warning(this.$t('kee_kp_view_in_mp'))
            }
        }
        const __int = setInterval(() => {
            if (
                document.getElementsByClassName('pv-video-wrap') &&
                document.getElementsByClassName('pv-video-wrap')[0] &&
                document.getElementsByClassName('pv-menu') &&
                document.getElementsByClassName('pv-menu')[0] &&
                document.getElementsByClassName('pv-menu')[0].getElementsByTagName('ul') &&
                document.getElementsByClassName('pv-menu')[0].getElementsByTagName('ul')[0]
            ) {
                clearInterval(__int)
                document.getElementsByClassName('pv-video-wrap')[0].addEventListener('contextmenu', function () {
                    document.getElementsByClassName('pv-menu')[0].getElementsByTagName('ul')[0].style.display = 'none'
                })
            } else {

            }
        }, 500)
    },
    computed: {
        courseId() {
            return this.$route.query.courseId
        },
        ...mapGetters('common', {
            getUser: 'getUser',
            getIfClientDrawerTag: 'getIfClientDrawerTag',
        }),
        isKpmgUser() {
            return this.getUser.userType === '1'
        }
    },
    methods: {
        durationTrans(v) {

            return [v[0], this.$t('hour'), v[1], this.$t('minute'), v[2], this.$t('second')].join(' ')
        },
        collectClick(item) {
            let param = {
                courseId: item.courseId,
                flag: item.collectFlag ? 0 : 1
            }
            API.insights.updateCollectFlagRecord(param).then((res) => {
                if (res.code === '1') {
                    if (item.collectFlag) {
                        item.collectFlag = 0
                    } else {
                        item.collectFlag = 1
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        myCourseClick() {
            let param = {
                courseId: this.courseId,
                flag: 1
            }
            API.insights.updateViewFlagRecord(param).then((res) => {
                if (res.code !== '1') {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        getCourseDetail() {
            this.loading = true
            let param = {
                courseId: this.courseId
            }
            return API.insights.queryCourseDetail(param).then((res) => {
                if (res.code === '1') {
                    this.courseInfo = res.data
                    if (this.courseInfo.form === 'ONLINE' && this.courseInfo.volumes && !this.isKpmgUser) {
                        this.watchVideo(this.courseInfo.volumes[0].videoId)
                        this.currentVideo = this.courseInfo.volumes[0].videoId
                    }
                    if (res.data.viewFlag === 0) {
                        this.myCourseClick()
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        watchVideo(videoId, isAutoplay) {
            if (this.isKpmgUser && this.courseInfo.form !== 'OFFLINE') {
            if(this.getIfClientDrawerTag ){
            this.$message.warning({
                dangerouslyUseHTMLString: true,
                message: '<span style="font-size: 12px;">'+this.$t('kee_kp_view_in_mp_new')+'</span>',
                duration: 5000
            }) 
            }else{
                this.$message.warning(this.$t('kee_kp_view_in_mp'))
            }
            }
            if (this.getUser.userType == '1') return
            this.currentVideo = videoId
            if (this.player) {
                this.player.destroy()
            }
            this.vid = videoId
            let param = {
                videoId: videoId
            }
            API.insights.getPlaySafeToken(param).then((res) => {
                if (res.code === '1') {
                    this.playsafe = res.data.token
                    if (isAutoplay) {
                        this.isAutoplay = isAutoplay
                    }
                    this.loadPlayerScript(this.loadPlayer)
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer
            let index = 0
            let nextPlaySafe = ''
            const option = {
                wrap: '#player',
                disposable: true,
                vid: this.vid,
                history_video_duration: 1,
                playsafe: this.playsafe,
                viewerInfo: {
                    viewerId: 'KCC_#' + this.getUser.userId // 观众ID
                },
                showLine: 'off'
            }
            if (this.isAutoplay) {
                option.autoplay = this.isAutoplay
            }


            this.player = polyvPlayer(option)
            this.player.on('s2j_onPlayStart', () => {
                //订阅视频开始播放事件
                console.info('视频开始播放')
                this.player.j2s_realPlayStatus((res) => { })
                index = this.courseInfo.volumes.findIndex((item) => item.videoId === option.vid)
                if (this.courseInfo.volumes.length > index + 1) {
                    index++
                }
                let param = { videoId: this.courseInfo.volumes[index].videoId }
                API.insights.getPlaySafeToken(param).then((res) => {
                    if (res.code === '1') {
                        nextPlaySafe = res.data.token
                    }
                })
            })
            this.player.on('s2j_onPlayOver', () => {
                //订阅视频开始播放事件
                option.vid = this.courseInfo.volumes[index].videoId
                option.playsafe = nextPlaySafe
                console.info('视频播放完毕', option)
                option.autoplay = true
                this.player.changeVid(option) // 切换下一个视频
                const currVideoIndex = this.courseInfo.volumes.findIndex((v) => v.videoId == this.currentVideo)


                if (currVideoIndex > -1) {
                    this.currentVideo = this.courseInfo.volumes[currVideoIndex + 1].videoId
                }

            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script')
                myScript.setAttribute('src', this.vodPlayerJs)
                myScript.onload = callback
                document.body.appendChild(myScript)
            } else {
                callback()
            }
        },
        goToMyCourse() {
            this.$router.push({ name: 'myCourse' })
        },
        openDetail(val) {
            this.courseInfo.volumes.map((item) => {
                if (item.videoId === val.videoId && item.remark) {
                    if (item.showDesc) {
                        this.$set(item, 'showDesc', false)
                    } else {
                        this.$set(item, 'showDesc', true)
                    }
                } else {
                    this.$set(item, 'showDesc', false)
                }
            })
        }
    },
    destroyed() {
        if (this.player) {
            this.player.destroy();
        }
    }
}
</script>
<style scoped>
.offline-course-box::-webkit-scrollbar {
  width: 8PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8PX !important;
}
.kee-b {
    margin: 0 200px;
    height: 40px;
    display: flex;
    align-items: center;
}
.detail-wrap {
    height: calc(100% - 46PX);
    background-color: #f3f3f3;
}

.wl-container-course-detail {
    color: #444;
    height: calc(100% - 70px - 40px);
    margin: 0 200px;
}
.wl-container-course-detail-drawer {
    margin: 0;
}

.wl-container-course-detail #player {
    height: 100%;
}

.wl-container-course-detail #player>div {
    height: 100% !important;
}

.wl-container-course-detail .__left {
    padding-right: 20px;
    height: 100%;
}

.wl-container-course-detail .__right {
    height: 100%;
}

.wl-container-course-detail .__inner {
    border-radius: 8px;
    background: #fff;
    padding: 15px;
    height: 100%;
}

.wl-container-course-detail .__left .__inner>div {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.course-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.course-header-title {
    font-size: 14PX;
    font-weight: bold;
    color: #333333;
}

.course-container {
    padding: 15px;
    margin-right: 20px;
    flex: 1;
}

.course-video {
    display: flex;
    /* min-height: 300px; */
    height: 45%;
}

.course-item {
    flex: 1;
    padding-top: 20px;
    height: 55%;
}

.video-content {
    /* min-height: 270px; */
    width: 45%;
    border-radius: 8px;
    /* border: 1px solid #dcdfe6; */
    margin-right: 15px;
    overflow: hidden;
}

.course-content {
    flex: 1;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.course-content .el-button {
    font-size: 14PX;
}

.course-content-detail {
    margin-top: 15px;
    margin-bottom: 20px;
    line-height: 1.5;
    font-size: 12PX;
    font-weight: normal;
}

.course-time {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.course-collect {
    color: #1b3bb9;
    font-size: 14px;
    display: flex;
    cursor: pointer;
    margin-left: 10px;
    align-items: center;
}

.collect-icon {
    height: 13px;
    width: 13px;
    margin-right: 3px;
}

.course-item-content {
    height: calc(100% - 47px);
    overflow: auto;
}

.course-item-content::-webkit-scrollbar {
  width: 8PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8PX !important;
}

.course-item-child {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #1E49E20F;
    padding: 10PX;
    line-height: 12PX;
    border-radius: 8PX;
    position: relative;
    overflow: hidden;
}

.isWatched {
    background-color: #e3e4e6;
}

.isWatched .course-play-slider {
    background: none !important;
}

.course-play-slider {
    position: absolute;
    height: 32PX;
    left: 0;
    opacity: 0.1;
}

.course-list-item-kc {
    margin-bottom: 12px;
    cursor: pointer;
}

.course-list-item-kc:last-child {
    margin-bottom: 0;
}

.item-title {
    padding-left: 10PX;
    font-size: 12PX;
    color: #333333;
    width: 60%;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
}

.item-title-active {
    font-weight: bold;
}

.isActive {
    color: #3879eb;
}

.course-item-label {
    display: flex;
    margin-right: 10px;
}

.item-time {
    color: #3879eb;
    display: flex;
    margin-left: auto;
}

.time-val {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    color: #666666;
}

.play-icon {
    width: 40px;
    text-align: center;
    z-index: 999;
}

i.play-icon {
    font-size: 16px;
}

.course-item-desc {
    padding-top: 12px;
}

.item-time i {
    cursor: pointer;
}

.course-pic {
    height: 438px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
}

.course-offline-content {
    margin-top: 15px;
    padding: 20px;
    border-radius: 8px;
    background-color: white;
}

.course-offline-title {
    font-size: 16px;
    font-weight: bold;
    color: #00338d;
}

.course-offline-child {
    margin-top: 15px;
    font-size: 14px;
    color: #333333;
    line-height: 1.5;
}

.course-price {
    margin: 20px 0;
    line-height: 14px;
}

.course-price .el-tag{
    font-size: 12PX;
    line-height: 22PX;
    padding: 0 5PX;
    height: 22PX;
}
.price-value {
    font-size: 14px;
    color: #fd349c;
    font-weight: bold;
}

.sales-content {
    color: #00c0ae;
    background-color: rgba(0, 154, 68, 0.1);
    padding: 5px 8px;
    border-radius: 20px;
}

.sales-content i {
    margin-right: 5px;
}

.qr-container {
    padding: 15px;
    border: 1px solid #1e49e2;
}

.qr-image {
    text-align: center;
    width: 100px;
}
.circle {
  display: flex;
  width: 20px;
  height: 20px;
  line-height: 20px;
  justify-content: center; /* 水平居中 */
  align-items: center;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #ccc;
}

.iconNew {
  --display: inline-block;
  --position: absolute;
  margin-left: 20px;
  background: url("~@/assets/img/kpicon-new-6.png") center center/100% 100% no-repeat;
  width: 63PX;
  height: 28PX;
  right: 10px;
  top: 10px;
}

.iconNew.__en {
  width: 63PX;
  height: 28PX;
  background: url("~@/assets/img/kpicon-new-3.png") center center/100% 100% no-repeat;
}

img {
    max-width: 80% !important;
}
</style>

